const selectSchedules = state => (state.schedules && state.schedules.data) || [];

export default selectSchedules;
